import {
  isPossiblePhoneNumber,
  isValidPhoneNumber,
  validatePhoneNumberLength
} from 'libphonenumber-js'

export const invoiceFieldValidator = (input, type, countryCode = null, data = null) => {
  let isValid = true;
  if (!input) input = '';
  switch (type) {
    case 'Name':
    case 'Address1':
      if (input.length === 0) isValid = false;
      break;
    case 'Telephone1':
    case 'Ref':
      // if(!data || input.length===0) isValid = false;
      // else if (input.length>0){
      //   isValid = data.test(String(input));
      // }
      break;
    case 'Zip':
      if (input.length === 0) isValid = false;
      else if (input.length > 0) {
        isValid = inputValidator(input, 'zip');
      }
      break;
    case 'City':
      if (input.length === 0) isValid = false;
      break;
    case 'OrgNo':
      if (input.length === 0) isValid = false;
      else if (input.length > 0) {
        isValid = validateOrgno(input, countryCode);
      }
      break;
    case 'GLN':
      if (input.length === 0) isValid = false;
      else if (input.length > 0) {
        // isValid = validateGln(input); //REMOVED GLN VALIDATION
        isValid = true;
      }
      break;
    case 'Email':
      if (input.length === 0) isValid = false;
      else if (input.length > 0) {
        isValid = inputValidator(input, 'email');
      }
      break;
    case 'CountryCode':
      if (input.length === 0) isValid = false;
      break;
    default:
      isValid = true;
  }
  return isValid;
};

const emailPattern =
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const phonePattern = /[^0-9+ \-()]/;

export function inputValidator(input, type) {
  console.log('validate', input, type);
  switch (type) {
    case 'zip':
      return true;
    case 'numeric':
      return !isNaN(input);
    case 'email':
      return emailPattern.test(String(input).toLowerCase());
    case 'telephone':
    case 'phone':
      return isValidPhoneNumber(input,  "SE");
    default:
      return true;
  }
}

export function validateGln(input) {
  // Test string for correct length
  if (!input) {
    return false;
  }
  input = input.replace(/[\s\-]/g, '');
  if (isNaN(input)) {
    return false;
  }
  // let data = input.split("");
  if (input.length != 13) {
    return false;
  }
  // Test string for being numeric
  for (let i = 0; i < input.length; i++) {
    if (input.charCodeAt(i) < 0x30 || input.charCodeAt(i) > 0x39) return false;
  }
  let weight = 1;
  let sum = 0;
  for (let i = 0; i < input.length - 1; i++) {
    sum += parseInt(input.charAt(i), 10) * weight;
    weight = (weight + 2) % 4;
  }
  let remainder = (10 - (sum % 10)) % 10;
  return input.charAt(input.length - 1) == 0 + remainder;
}

export function validateOrgno(input, countryCode, company = true) {
  if (!input) {
    return false;
  }
  input = input.replace(/[\s\-]/g, '');
  if (isNaN(input)) {
    return false;
  }
  switch (countryCode) {
    case 'NOR':
      //norweigan company
      if (input.length == 9) {
        let o = input.split('').map(i => {
          return parseInt(i, 10);
        });
        if (input.length == 9) {
          let sum = o[0] * 3 + o[1] * 2 + o[2] * 7 + o[3] * 6 + o[4] * 5 + o[5] * 4 + o[6] * 3 + o[7] * 2;
          let rest = sum % 11;
          let kontrollsiffer = rest === 0 ? 0 : 11 - rest;

          return rest != 1 && kontrollsiffer == o[8];
        } else {
          return false;
        }
      }
      //norweigan person
      else if (input.length == 11) {
        if (input.length != 11) return false;
        const staticSequenceFirstCheckDigit = [3, 7, 6, 1, 8, 9, 4, 5, 2, 1];
        const staticSequenceSecondCheckDigit = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2, 1];
        const elevenDigitsArray = input.split('').map(x => parseInt(x));

        const isValidCheckDigit = (staticSequence, digits) => {
          var productSum = staticSequence.reduce((acc, value, index) => acc + value * digits[index], 0);

          return productSum % 11 === 0;
        };

        return isValidCheckDigit(staticSequenceFirstCheckDigit, elevenDigitsArray) && isValidCheckDigit(staticSequenceSecondCheckDigit, elevenDigitsArray);
      } else {
        return false;
      }
    case 'SWE':
      //swedish person and company
      // Check valid length & form
      let numdigits = input.length;
      if (input.indexOf('-') === -1) {
        if (input.length === 10) {
          input = input.slice(0, 6) + '-' + input.slice(6);
        } else {
          input = input.slice(0, 8) + '-' + input.slice(8);
        }
      }
      if (!input.match(/^(\d{2})(\d{2})(\d{2})\-(\d{4})|(\d{4})(\d{2})(\d{2})\-(\d{4})$/)) {
        return false;
      }
      // Clean input
      input = input.replace('-', '');
      if (input.length === 12) {
        input = input.substring(2);
      }
      let sum = 0;
      // Check luhn algorithm
      for (let i = 0; i < input.length; i = i + 1) {
        let digit = parseInt(input.charAt(i), 10);
        if (i % 2 === input.length % 2) {
          digit *= 2;
        }
        if (digit > 9) {
          digit -= 9;
        }
        sum += digit;
      }
      return sum % 10 === 0;
    default:
      return true;
  }
}

export function hasOrgNoValidation(countryCode) {
  switch (countryCode) {
    // case "DNK":
    case 'NOR':
    case 'SWE':
      return true;
    default:
      return false;
  }
}